//
//
//
//
//
//
//
//
//

import {
  ALERT_VARIANTS,
  ALERT_VARIANT_BLUE,
  ALERT_VARIANT_DEFAULT,
  ALERT_VARIANT_GREEN,
  ALERT_VARIANT_RED,
  ALERT_VARIANT_YELLOW,
} from '../../utils/constants'
export default {
  props: {
    variant: {
      type: String,
      default: null,
      validator: (x) => Object.keys(ALERT_VARIANTS).includes(x),
    },
    icon: {
      type: [String, Object],
      default: null,
    },
  },
  computed: {
    alertClass() {
      const base = [
        'tw-flex',
        'tw-items-center',
        'tw-gap-2.5',
        'tw-rounded-lg',
        'tw-border',
        'tw-text-sm',
      ]
      return [...base, this.variantClass]
    },
    variantClass() {
      switch (this.variant) {
        case ALERT_VARIANT_BLUE:
          return 'tw-border-blue-100 tw-bg-blue-50 tw-text-blue-700'
        case ALERT_VARIANT_GREEN:
          return 'tw-border-green-100 tw-bg-green-50 tw-text-green-700'
        case ALERT_VARIANT_RED:
          return 'tw-border-red-100 tw-bg-red-50 tw-text-red-700'
        case ALERT_VARIANT_YELLOW:
          return 'tw-border-yellow-200 tw-bg-yellow-50 tw-text-yellow-700'
        case ALERT_VARIANT_DEFAULT:
        default:
          return 'tw-bg-white tw-text-gray-700'
      }
    },
  },
}
